
$(document).ready(function(){

    var face_look = 0;
    var improve = 0;
    var tried = 'yes';
    var current_question = 0;
    var chosen;
    var score = 60;
    var fname = "";
    var answers;
    var selected = false;



      var questions = [
        {
          question: "What is your age?",
          options: [
            {
              option: "16 – 25",
              value: 0
            },
            {
              option: "26 – 35",
              value: -2
            },
            {
              option: "35 – 45",
              value: -5
            },
            {
              option: "45 – 60",
              value: -8
            },
            {
              option: "60+",
              value: -10
            },
          ]
        },
        {
          question: "What does a typical meal look like?",
          options: [
            {
              option: "Chicken and salad",
              value: 5
            },
            {
              option: "Burgers and fries ",
              value: -5
            },
            {
              option: "Frozen food",
              value: 0
            },
            {
              option: "Beer and take out ",
              value: -5
            },
          ]
        },
        {
          question: "How many hours of sleep do you get a night?",
          options: [
            {
              option: "1 - 4",
              value: -5
            },
            {
              option: "5 - 6",
              value: 0
            },
            {
              option: "7+",
              value: 1
            },
          ]
        },
        {
          question: "How many glasses of water do you drink daily?",
          options: [
            {
              option: "1 - 3",
              value: -4
            },
            {
              option: "4 - 5",
              value: 1
            },
            {
              option: "6 - 7",
              value: 3
            },
            {
              option: "8+",
              value: 5
            },
          ]
        },
        {
          question: "At the end of the day, does your face look:",
          options: [
            {
              option: "Dry or parched",
              value: 0
            },
            {
              option: "Same as when you woke up",
              value: 0
            },
            {
              option: "Oily or shiny",
              value: 0
            },
          ]
        },
        {
          question: "How often do you exfoliate?",
          options: [
            {
              option: "Every day",
              value: -2
            },
            {
              option: "Weekly",
              value: 3
            },
            {
              option: "A few times a month",
              value: 0
            },
            {
              option: "Never",
              value: -2
            },
          ]
        },
        {
          question: "Do you smoke?",
          options: [
            {
              option: "Yes",
              value: -10
            },
            {
              option: "No",
              value: 5
            },
          ]
        },
        {
          question: "What about your skin would you most like to improve?",
          options: [
            {
              option: "Fine lines and wrinkles",
              value: 0
            },
            {
              option: "",
              value: 0
            },
            {
              option: "Daily skin care",
              value: 0
            },
            {
              option: "Tired eyes",
              value: 0
            },
            {
              option: "Oily skin",
              value: 0
            },
            {
              option: "Even skin tone",
              value: 0
            },
            {
              option: "Large pores",
              value: 0
            },
            {
              option: "",
              value: 0
            }
          ]
        },
        {
          question: "What does your current skin care routine look like?",
          options: [
            {
              option: "I don’t have one",
              value: -4
            },
            {
              option: "I use some face wash",
              value: 0
            },
            {
              option: "I wash my face, moisturize, and maybe use a few other products",
              value: 5
            },
            {
              option: "I have a full routine that includes daily skin care and anti aging",
              value: 5
            },
          ]
        },
        {
          question: "Have you tried our free sample kit?",
          options: [
            {
              option: "Yes",
              value: 0
            },
            {
              option: "No",
              value: 0
            },
          ]
        },
      ];
        var articles = [
          [
        {
            title: "Skin Care Routine for Men With Dry Skin",
            link: "/blogs/grooming-manual/89761155-skin-care-routine-for-men-with-sensitive-or-dry-skin"
        },
        {
            title: "The Top 5 Anti Aging Tips for Men",
            link: "/blogs/grooming-manual/66267203-top-5-anti-aging-tips-for-men"
        }
          ],
          [
        {
            title: "A Men's Skin Care Routine",
            link: "/blogs/grooming-manual/67369987-advanced-mens-skin-care-routine"
        },
        {
            title: "The Top 5 Anti Aging Tips for Men",
            link: "/blogs/grooming-manual/66267203-top-5-anti-aging-tips-for-men"
        }
          ],
          [
        {
            title: "How to Prevent Excess Oily Skin",
            link: "/blogs/grooming-manual/86457667-men-how-to-prevent-excess-oily-skin"
            },
        {
            title: "A Men's Skin Care Routine",
            link: "/blogs/grooming-manual/67369987-advanced-mens-skin-care-routine"
        }
          ],
      ];


        var customs_face = [

        [
          {
            text: 'Our <a href="/products/face-wash-for-men">Purifying Charcoal Face Wash</a> to cleanse skin while hydrating and not over drying.',
            id: 'face-wash-for-men'
          },
          {
            text: 'Our <a href="/products/mens-face-moisturizer">Daily Essential Face Moisturizer</a> hydrates your skin for all day moisture.',
            id: 'mens-face-moisturizer'
          },
          {
            text: 'Our <a href="/products/reviving-day-mens-face-serum">Reviving Day Serum</a> provides nutrients to deep down skin cells, while stimulating collagen production.',
            id: 'reviving-day-mens-face-serum'
          }
        ],
        [
          {
            text: 'Our <a href="/products/balancing-toner-for-men">Balancing Toner</a> to even out skin tone and minimize pores.',
            id: 'balancing-toner-for-men'
          },
          {
            text: 'Our <a href="/products/clarifying-gel-face-wash-for-men">Clarifying Gel Face Wash</a> to help remove impurities and leave the face feeling refreshed.',
            id: 'clarifying-gel-face-wash-for-men'
          },
          {
            text: 'Our <a href="/products/mens-face-scrub">Renewing Face Scrub</a> to remove dead skin, impurities and pore build up.',
            id: 'mens-face-scrub'
          },
          {
            text: 'Our lightweight <a href="/products/mens-face-moisturizer">Daily Essential Face Moisturizer</a> to add hydration without shine.',
            id: 'mens-face-moisturizer'
          }
        ],
        [
          {
            text: 'Our <a href="/products/clarifying-gel-face-wash-for-men">Clarifying Gel Face Wash</a> to to help remove oil and prevent shine.',
            id: 'clarifying-gel-face-wash-for-men'
          },
          {
            text: 'Our <a href="/products/mens-face-scrub">Renewing Face Scrub</a> to remove dead skin, impurities and pore build up.',
            id: 'mens-face-scrub'
          },
          {
            text: 'Our lightweight <a href="/products/mens-face-moisturizer">Daily Essential Face Moisturizer</a> to add hydration without shine.',
            id: 'mens-face-moisturizer'
          }
        ]

      ];
        var skin_type = ["dry", "normal", "oily/combo"];

        var customs_improve = [
        {
          title: "We recommend one of our serums:",
          products: [
            {
              name: "Reviving Day Serum",
              picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Reviving_grande.png",
              link: "/products/reviving-day-mens-face-serum",
              id: 9344633486
            },
              {
              name: "Repairing Night Serum",
              picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Repairing_grande.png",
              link: "/products/repairing-night-mens-face-serum",
              id: 9344403278
            },
            {
              name: "Daily Defense Face Moisturizer",
              picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/2oz_Daily_Defense_Face_Moisturizer_855767007706.png?v=1544714993",
              link: "/products/best-mens-face-moisturizer-with-spf",
              id: 1319914111051
            }
          ]
        },
        {
          title: "We recommend our serums and anti aging cream:",
          products: [
            {
              name: "Reviving Day Serum",
              picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Reviving_grande.png",
              link: "/products/reviving-day-mens-face-serum",
              id: 9344633486
            },
              {
              name: "Repairing Night Serum",
              picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Repairing_grande.png",
              link: "/products/repairing-night-mens-face-serum",
              id: 9344403278
            },
            {
              name: "Revitalizing Anti-Aging Cream",
              picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/AntiAgingCream_2048_Rev1_grande.png",
              link: "/products/anti-aging-cream-for-men",
              id: 331270471
            },
          ]
        },
        {
          title: "We recommend our Daily Advanced Skin Care Routine:",
          products: [
            {
              name: "Men's Daily Advanced Face Care Routine",
              picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/mens_skincare_set_1024x1024_49b908f9-a78b-4382-bbb7-d0e152706ca2_grande.png",
              link: "/products/mens-daily-advanced-face-care-routine-i",
              id: 10022865870
            },
            {
              name: "Daily Defense Face Moisturizer",
              picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/2oz_Daily_Defense_Face_Moisturizer_855767007706.png?v=1544714993",
              link: "/products/best-mens-face-moisturizer-with-spf",
              id: 1319914111051
            }
          ]
        },
        {
          title: "We recommend our Restoring Eye Balm:",
          products: [
            {
              name: "Restoring Eye Cream",
              picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Brickell_Restoring_Eye_Balm_.5oz.png",
              link: "/products/best-eye-cream-for-men",
              id: 413218603
            },
          ]
        },
        {
          title: "We recommend our Clarifying Gel Cleanser:",
          products: [
            {
              name: "Clarifying Gel Face Wash",
              picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/best_face_wash_for_men_grande.png",
              link: "/products/clarifying-gel-face-wash-for-men",
              id: 450323531
            },
            {
              name: "Balancing Toner",
              picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Balancing_Toner_1.png",
              link: "/products/balancing-toner-for-men",
              id: 1331683885131
            }
          ]
        },
        {
          title: "We recommend our Advanced Anti Aging Routine:",
          products: [
            {
              name: "Reviving Day Serum",
              picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Reviving_grande.png",
              link: "/products/reviving-day-mens-face-serum",
              id: 9344633486
            },
              {
              name: "Repairing Night Serum",
              picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Repairing_grande.png",
              link: "/products/repairing-night-mens-face-serum",
              id: 9344403278
            },
            {
              name: "Advanced Anti Aging Routine",
              picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Repairing_Group_1024x1024_7e317f6f-6605-402f-b515-d3e620df83ff_grande.png",
              link: "/products/advanced-anti-aging-routine",
              id: 9441347918
            },
            {
              name: "Balancing Toner",
              picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Balancing_Toner_1.png?v=1544726653",
              link: "/products/balancing-toner-for-men",
              id: 1331683885131
            }
          ]
        },
        {
          title: "We recommend our Daily Advanced Skin Care Routine:",
          products: [
            {
              name: "Men's Daily Advanced Face Care Routine",
              picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/mens_skincare_set_1024x1024_49b908f9-a78b-4382-bbb7-d0e152706ca2_grande.png",
              link: "/products/mens-daily-advanced-face-care-routine-i",
              id: 10022865870
            },
            {
              name: "Balancing Toner",
              picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Balancing_Toner_1.png?v=1544726653",
              link: "/products/balancing-toner-for-men",
              id: 1331683885131
            }

          ]
        }

        ];

      if (Cookies.get("score")) {
        console.log(Cookies.get("score"));
        console.log(Cookies.get("fname"));
          score = Math.floor(Cookies.get("score"));
          fname = Cookies.get("fname");
          improve = Cookies.get("improve");
          face_look = Cookies.get("face_look");
          tried = Cookies.get('tried');
          showResults();
          $(".results").show();
          $(".question, .introduction").hide();

      }


        $("#content").css("border-bottom", 0).css("padding-top", 0);
        $(".start").click(function(){
        console.log('111');
        $('.skin-test').addClass('started');
        answers = [];
        $(".test-progress h5").text("1 of 10");
        $(".back").hide();
            var question = questions[current_question];
        $(".introduction").hide();
        $(".question").not(".email").show();
          $(".question h4").text(question.question);
            loadQuestions(question);
      });

    $(".retake a").click(function(e){
      e.preventDefault();
        Cookies.remove("score");
      Cookies.remove("fname");
      Cookies.remove("improve");
      Cookies.remove("tried");
      Cookies.remove("face_look");
      score = 60;
      answers = [];
      $(".introduction").show();
      $(".results").hide();
      current_question = 0;
      $(".options").empty();
      $('section.k3, section.k2').hide();
      $(".recommended-articles .articles").empty();
    });
      $(".back").click(function(){
        $('.option.selected').removeClass('selected');
        if (face_look == 0 && current_question == 5) {
            questions[8].options = [
            {
              option: "Fine lines and wrinkles",
              value: 0
            },
            {
              option: "Firmer, tighter look",
              value: 0
            },
            {
              option: "Daily skin care",
              value: 0
            },
            {
              option: "Tired eyes",
              value: 0
            },
            {
              option: "Oily skin",
              value: 0
            },
            {
              option: "Even skin tone",
              value: 0
            },
            {
              option: "Large pores",
              value: 0
            },
          ];
        }

          current_question--;
        $(".test-progress h5").text((current_question + 1) + " of 10");
        if (current_question == 0) {
            $(".back").hide();
        }
            score -= questions[current_question].options[answers[current_question]].value;
            var question = questions[current_question];
           $(".question h4").text(question.question);
          $(".options").empty();
          loadQuestions(question);
          answers.pop();
      });
  function showResults() {
    Cookies.set("taken", 1);
    if (face_look == 0 && improve == 2) {
      customs_improve[2].products[0].name = "Men's Daily Essential Face Care Routine II";
              customs_improve[2].products[0].picture = "https://cdn.shopify.com/s/files/1/0513/2409/products/mens_facial_lotion_and_mens_face_cleanser.png?v=1489348572";
            customs_improve[2].products[0].link = "/products/mens-daily-essential-face-care-routine-charcoal";
           customs_improve[2].products[0].id = 463158847;
          }
    if ((face_look == 1 || face_look == 3) && improve == 2) {
      customs_improve[2].products[0].name = "Men's Daily Advanced Face Care Routine I";
              customs_improve[2].products[0].picture = "https://cdn.shopify.com/s/files/1/0513/2409/products/mens_skincare_set_1024x1024_49b908f9-a78b-4382-bbb7-d0e152706ca2_1024x1024.png?v=1489371856";
            customs_improve[2].products[0].link = "/products/mens-daily-advanced-face-care-routine-i";
            customs_improve[2].products[0].id = 10022865870;
          }

  var result = "";
          if (score <= 20) {
              result = "Your skin is in very bad shape. You need to change your lifestyle and upgrade your skin care routine.";
          } else if (score >= 21 && score <= 40) {
              result = "Your skin is not in good shape.";
          } else if (score >= 41 && score <= 60) {
              result = "Your skin is in ok shape.";
          } else if (score >= 61 && score <= 80) {
              result = "You have decent skin but there is room for improvement.";
          } else if (score >= 81 && score <= 90) {
              result = "Your skin is in good shape but there is room for improvement.";
          } else if (score > 90) {
              result = "Your skin is in excellent shape.";
          }
    if (tried == "1") {
        result += ' Based on your answers, we recommend trying our <a href="/products/brickell-mens-best-sellers-sample-kit">Free Sample Kit</a>.';
    } else {
        result += ' See our recommendations below on how to improve.';
    }
    $(".recommended-articles .articles").empty();
  for (var i = 0; i < 2; i++) {
      //$(".recommended-articles .articles").append("<p><a href='" + articles[face_look][i].link + "'>" + articles[face_look][i].title + "</a></p>")

    }
    $(".ttlAfter").hide();
    $(".ttlBefore").show();
          $(".results h3").text("Hey " + fname + ", your score is: " + score + " out of 100");
    if (tried == "1") {
      //$(".results .custom-face h3").html('');
      //$(".custom-face p").html(customs_face[face_look]);
     $(".custom-face p").html(text_suggestions);
        $('section.k3, section.k2').show();
      $('.custom-face .sample-kit-container').show();
      $('.custom-face .suggested-container').hide();
      $(".custom-improve").hide();
      $(".skin-test").addClass("tried");
    } else {
       //$("#resultsp").html(customs_face[face_look]);
      $(".skin-test").removeClass("tried");
      $(".results .custom-face > h6.title").html('Based on your answers and your ' + skin_type[face_look] + ' skin, we recommend these products:');
        $(".custom-face .suggested-container .product").hide();
      var text_suggestions = "";
      for (var i = 0; i < customs_face[face_look].length; i++) {
            $(".custom-face .suggested-container .product." + customs_face[face_look][i].id).show();
          text_suggestions += customs_face[face_look][i].text + "<br><br>";
      }
      //$(".custom-face p").html(text_suggestions);
      $('.custom-face .sample-kit-container').hide();
      $('.custom-face .suggested-container').show();
      if (improve == 7) {
            $(".custom-improve").hide();
          } else {
            $(".custom-improve").show();
            $(".custom-improve h3").text("To help with your objective of " + questions[7].options[improve].option + ", we suggest learning more about the following products:");
            $(".results .custom-improve .products").empty();
            for (var i = 0; i < customs_improve[improve].products.length; i++) {
              $(".results .custom-improve .products").append("<div class='product span3'><img src='" + customs_improve[improve].products[i].picture + "'><h3>" + customs_improve[improve].products[i].name + "</h3><div class='yotpo bottomLine' data-appkey='HB2ysZp6ROjiio3fXMJ9LrRGvuyn37u7yRzh3BC2' data-domain='{{ shop.permanent_domain | escape }}' data-product-id='" + customs_improve[improve].products[i].id + "' data-product-models='" + customs_improve[improve].products[i].id + "'></div><a href='" + customs_improve[improve].products[i].link + "' class='button'>Add to Cart</a></div>");
            }
          }
    }
          $(".results .score-details").html(result);


  }
        function loadQuestions(question) {
            for (var j = 0; j < question.options.length; j++) {
            if (question.options[j].option != "") {
              $(".options").append("<div class='option'><input type='radio' style='display:none;' id='" + j + '' + current_question + "' value='" + j + "' name='" + current_question + "' /><label for='" + j + '' + current_question + "'>" + question.options[j].option + "</label></div>");
            }
          }
          $("input[name='" + current_question + "']").change(function(){
            if (!selected) {
                $(this).parent().addClass('selected');
            }
            selected = true;
            setTimeout(function(){
                console.log(current_question);

        if (!isNaN(parseInt($("input[name='" + current_question + "']:checked").val()))) {
          chosen = parseInt($("input[name='" + current_question + "']:checked").val());
          answers.push(chosen);
            $(".back").show();
          switch (current_question) {
            case 4:
              face_look = chosen;
              if (chosen == 0) {
                  questions[7].options[4].option = "";
                    questions[7].options[6].option = "";
              } else {
                  questions[7].options[4].option = "Oily skin";
                    questions[7].options[6].option = "Large pores";
              }
              break;
            case 7:
              improve = chosen;
              console.log(chosen);
              break;
            case 9:
              tried = chosen;
              break;
          }

            score += questions[current_question].options[chosen].value;
            //console.log(score);
            current_question++;
        $(".test-progress h5").text((current_question + 1) + " of 10");
        if (current_question == questions.length) {

            $(".question").hide();
  //         $(".results").show();
          if (Cookies.get("taken") != "1") {
              $(".email h2").text("What is your first name and email address?");
            $(".email.question").show();
            $(".email.question form").submit(function(e){
              if ($('#quiz_signup input[name=first_name]').val() == '' || $('#quiz_signup input[name=email]').val() == '') {
                  return;
              }
                $(".email.question").hide();
                $(".results").show();
                fname = $("input[name='first_name']").val();
              Cookies.set("fname", fname);
              Cookies.set("tried", tried);
              Cookies.set("score", score);
                Cookies.set("face_look", face_look);
                Cookies.set("improve", improve);
              showResults();

            });
          } else {
              $(".results").show();
                fname = $("input[name='first_name']").val();
              Cookies.set("fname", fname);
              Cookies.set("tried", tried);
              Cookies.set("score", score);
                Cookies.set("face_look", face_look);
                Cookies.set("improve", improve);
              showResults();
          }



        } else {
            var question = questions[current_question];
           $(".question h4").text(question.question);
          $(".options").empty();
          loadQuestions(question);
        }
        }
            selected = false;
            }, 500);

          });
        }
  });